import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import {customOktaAuthGuard} from './core/authorization/custom.okta.auth.guard';
import { redirectGuard } from './core/authorization/redirect.guard';
import { PageNotFoundModule } from './components/page-not-found/page-not-found.module';
import {LoginCallbackComponent} from './modules/auth/login-callback/login-callback.component';

export const routes: Routes = [
    {
        path: 'auth',
        canActivate: [customOktaAuthGuard],
        loadChildren: () =>
            import('./modules/auth/auth.module').then((m) => m.AuthModule),
    },
    {
        path: 'health',
        canActivate: [customOktaAuthGuard],
        loadChildren: () =>
            import('./modules/health/health-rxdb.module').then((m) => m.HealthRxdbModule),
    },
    {
        path: 'error',
        loadChildren: () =>
            import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
    },
    {
        path: '',
        canActivate: [redirectGuard, customOktaAuthGuard],
        loadChildren: () =>
            import('./pages/layout.module').then((m) => m.LayoutModule),
    },
    {path: 'login/callback', component: LoginCallbackComponent},
    { 
        path: '**', 
        component: PageNotFoundComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes), PageNotFoundModule],
    exports: [RouterModule],
})
export class AppRoutingModule {

}
